import { render, staticRenderFns } from "./ProjectsGallery.vue?vue&type=template&id=22d219f8&scoped=true&"
import script from "./ProjectsGallery.vue?vue&type=script&lang=js&"
export * from "./ProjectsGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsGallery.vue?vue&type=style&index=0&id=22d219f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d219f8",
  null
  
)

export default component.exports